module.exports = __webpack_public_path__ + "static/media/loading.bb6d2f84.gif";